export const getOrder = (
  item:
    | 'inicio'
    | 'categorias'
    | 'servicos_destaque'
    | 'indicadores'
    | 'banners'
    | 'banners_rotative'
    | 'canais_atendimento'
    | 'noticias'
    | 'agenda_cultural'
    | 'app_governo'
    | 'persona'
    | 'videos',
): number => {
  const order: Array<any> =
    process.env.REACT_APP_ORDER_HOME_PAGE.split(',') ?? []

  return order.findIndex((findOrder) => findOrder === item)
}

export default { getOrder }
